module.exports = __webpack_public_path__ + "img/mod-10.76b93858.svg";